module.exports = __webpack_public_path__ + "src/assets/img/st2.9ef1d4ba.svg";